/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddVersionRequest
 */
export interface AddVersionRequest {
    /**
     * 
     * @type {string}
     * @memberof AddVersionRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddVersionRequest
     */
    platform: AddVersionRequestPlatformEnum;
    /**
     * 
     * @type {any}
     * @memberof AddVersionRequest
     */
    data?: any | null;
}


/**
 * @export
 */
export const AddVersionRequestPlatformEnum = {
    Ios: 'ios',
    Android: 'android',
    Electron: 'electron'
} as const;
export type AddVersionRequestPlatformEnum = typeof AddVersionRequestPlatformEnum[keyof typeof AddVersionRequestPlatformEnum];


/**
 * Check if a given object implements the AddVersionRequest interface.
 */
export function instanceOfAddVersionRequest(value: object): value is AddVersionRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function AddVersionRequestFromJSON(json: any): AddVersionRequest {
    return AddVersionRequestFromJSONTyped(json, false);
}

export function AddVersionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddVersionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'platform': json['platform'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function AddVersionRequestToJSON(json: any): AddVersionRequest {
    return AddVersionRequestToJSONTyped(json, false);
}

export function AddVersionRequestToJSONTyped(value?: AddVersionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'platform': value['platform'],
        'data': value['data'],
    };
}

